import { isPlatformBrowser } from '@angular/common';
import { Component, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { AppSubscribeNewsletterCoreComponent } from '../subscribe-newsletter/subscribe-newsletter-core.component';
import { SubscribeNewsletterModalService } from '@scalefast/ecommerce-core';

@Component({
  selector: 'app-newsletter-modal',
  templateUrl: 'subscribe-newsletter-modal.component.html',
  standalone: true,
  imports: [AppSubscribeNewsletterCoreComponent],
  styleUrl: './subscribe-newsletter-modal.component.scss',
})
export class AppSubscribeNewsletterModalComponent implements OnInit {
  subscribeNewsletterModalService = inject(SubscribeNewsletterModalService);
  platformId = inject(PLATFORM_ID);
  sourceId = 'newsletter-popup';

  /** This component is always rendered in SSR.
   * When initialize, it checks if 'hide_newsletter' is present in local storage,
   * and set the CSS variable value (--subscribe-newsletter-display) accordingly
   * The modal display is managed by that CSS variable.
   */
  ngOnInit() {
    if (this.subscribeNewsletterModalService.shouldIShowModalOnLoad()) {
      this.subscribeNewsletterModalService.showModal();
      if (!isPlatformBrowser(this.platformId)) {
        return;
      }
      document.body.classList.add('modal-open');
    }
  }

  close() {
    this.subscribeNewsletterModalService.hideModalAndSetLocalStorage();
  }
}
